import {
    useMutation,
    UseMutationResult,
} from '@tanstack/react-query'
import {
    useJWTToken,
} from 'app/Auth'

import useHandleStatusRequest from 'app/hooks/useHandleStatusRequest'

import {
    OrderModificationType,
} from 'app/enums/label.enums'
import requests from 'app/requests/Order/Order.requests'

import simpleApi from 'app/services/simpleApi'
import {
    RelinkLaneType,
} from '../dataUpdate.types'

type RequestParams = {
    orderNumber: string,
    data: Omit<RelinkLaneType, 'modificationType'>,
    modificationType: OrderModificationType,
}

const useRelinkLane = (onSuccess: () => void)
    : UseMutationResult<unknown, unknown, RequestParams> => {
    const token = useJWTToken()
    const {
        onSuccess: onSuccessRelink,
        onError,
    } = useHandleStatusRequest({
        id: 'RelinkLaneOrder',
        title: 'Relink Lane',
        onSuccess,
    })

    return useMutation({
        mutationFn: ({
            modificationType,
            orderNumber,
            data,
        }: RequestParams) => {
            return simpleApi({
                ...requests.updateLane({
                    orderNumber,
                    modificationType,
                    data,
                }),
                token,
            })
        },
        onSuccess: onSuccessRelink,
        onError,
    })
}

export default useRelinkLane
